'use client';

import { type FC } from 'react';

import type { IDrawerProps } from './types';
import { DrawerInternal } from './internal/DrawerInternal';
import { useIsMounted } from '../hooks/useIsMounted';

/**
 * A drawer is an overlay, that slides into the view and is displayed above other content.
 * @throws Error if used outside of a DrawersProvider.
 */
export const Drawer: FC<IDrawerProps> = ({
  open,
  children,
  fromLeft = false,
  'aria-label': ariaLabel,
  rootClassName = '',
  showCurtain = false,
  curtainClassName = '',
  drawerClassName = '',
  usePortal = true
}) => {
  const isMounted = useIsMounted();

  return (
    <>
      {isMounted && (
        <DrawerInternal
          open={open}
          fromLeft={fromLeft}
          aria-label={ariaLabel}
          rootClassName={rootClassName}
          showCurtain={showCurtain}
          curtainClassName={curtainClassName}
          drawerClassName={drawerClassName}
          usePortal={usePortal}
        >
          {children}
        </DrawerInternal>
      )}
    </>
  );
};
